import Api from "../Api/Api";

export const getEventCodes = () => {
  return Api.get("admin/getEventCodes");
};

export const generateEventCode = () => {
  return Api.post("admin/generateEventCode");
};

export const deleteEventCode = (code) => {
  return Api.delete(`admin/deleteEventCode?code=${code}`);
};

export const updateEventCodeNote = (code, note) => {
  return Api.put("admin/updateEventCodeNote", { code, note });
}; 